import { corridorRelayQuery } from "@common/api/corridor-relay"
import { Card } from "@common/components/ui/card"
import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { PageContent, PageTitle } from "@/components/page/page-content"
import useCustomToast from "@/hooks/use-custom-toast"
import { requirePermission } from "@/lib/require-permission"
import { RelayForm } from "./-components/form/relay-form"

export const Route = createFileRoute(
  "/_layout/settings/_panel/integrations/erp/relay/set",
)({
  staticData: { breadcrumb: "Desktop relay" },
  beforeLoad: ({ context: { queryClient } }) =>
    requirePermission(
      queryClient,
      "erp_config:update",
      "/settings/workspace/general",
    ),
  loader: ({ context: { queryClient } }) =>
    queryClient.ensureQueryData(corridorRelayQuery()),
  component: SetRelayPage,
})

function SetRelayPage(): React.ReactElement {
  const navigate = useNavigate()
  const showToast = useCustomToast()
  const {
    data: { relay },
  } = useSuspenseQuery(corridorRelayQuery())

  const saved = () => {
    showToast("Saved", "Quotes can now be sent to Corridor.", "success")
    navigate({ to: "/settings/integrations/erp" })
  }

  return (
    <PageContent>
      <PageTitle title="Corridor desktop relay" />
      <Card className="space-y-4 p-4 shadow-none">
        <p className="text-small-regular text-muted-foreground">
          Quotes are sent to the Corridor desktop through this relay. Paste the
          relay's MCP key; it is stored encrypted and never shown again.
        </p>
        <RelayForm url={relay?.url} onSave={saved} />
      </Card>
    </PageContent>
  )
}
